export type Locale = "fr" | "en";

const KEY = "CRM.locale";

export const getStoredLocale = (): Locale | null => {
  try {
    const v = localStorage.getItem(KEY);
    return v === "fr" || v === "en" ? v : null;
  } catch {
    return null;
  }
};

export const storeLocale = (l: Locale) => {
  try {
    localStorage.setItem(KEY, l);
  } catch {
    /* private mode: ignore */
  }
};

// French is the product default (spec 10 §6); the browser language is intentionally ignored.
export const resolveInitialLocale = (
  stored: Locale | null,
  _browser?: string,
): Locale => stored ?? "fr";
